<template>
    <div>
        <top-bar
            :height="'48vh'"
            title="活动"
            addTitle="添加"
            :isShowRefresh="true"
            :loading="loading"
            @refresh="refresh"
            @add="add"
            @search="search"
        />
        <v-container fluid class="mt-n6">
            <activity-table :activityInfos="activityInfos" @edit="edit" :loading="loading" />
        </v-container>
        <v-dialog scrollable v-model="isOpneDialog" width="30em" overlay-color="#262626">
            <activity-form
                v-if="isOpneDialog"
                @cancel="cancel"
                @refresh="refresh"
                :isAdd="isAdd"
                :isEdit="isEdit"
                :activityInfo="activityInfo"
            />
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store";
import util from "@/util/index";
import Public from "@/public";
import TopBar from "@/components/TopBar";
import ActivityForm from "@/components/Form/ActivityForm";
import ActivityTable from "@/components/Table/ActivityTable";
export default {
    name: "Activity",
    data() {
        return {
            loading: false,
            isOpneDialog: false,
            isAdd: false,
            isEdit: false,
            activityInfo: null,
        };
    },
    watch: {
        activityInfo: {
            handler(val) {
                // this.isOpneDialog = false;
                // this.$nextTick(() => {
                //     this.isOpneDialog = true;
                // });
            },
            deep: true,
        },
    },
    mounted() {},
    components: {
        TopBar,
        ActivityForm,
        ActivityTable,
    },
    computed: {
        ...mapState(["activityInfos"]),
    },
    methods: {
        /*刷新*/
        refresh() {
            this.getData();
        },
        /*搜索*/
        search(reg) {
            console.log(reg);
        },
        /*获取数据*/
        async getData() {
            this.loading = true;
            let params = {
                postData: {
                    from: 0,
                    limit: 10,
                },
                callback: () => {
                    this.loading = false;
                },
            };
            await store.dispatch("getActivity", params);
        },
        /*添加活动*/
        add() {
            this.isAdd = true;
            this.isOpneDialog = true;
        },
        /*修改信息*/
        edit(activityInfo) {
            this.isOpneDialog = true;
            this.isEdit = true;
            this.activityInfo = activityInfo;
        },
        /*取消*/
        cancel() {
            this.activityInfo = null;
            this.isOpneDialog = false;
            this.isAdd = false;
            this.isEdit = false;
        },
    },
};
</script>
